import { render } from "./MarketingView.vue?vue&type=template&id=0364dd47&scoped=true"
import script from "./MarketingView.vue?vue&type=script&lang=js"
export * from "./MarketingView.vue?vue&type=script&lang=js"

import "./MarketingView.vue?vue&type=style&index=0&id=0364dd47&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0364dd47"]])

export default __exports__